import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import BindingContext, { createPath } from "@odata/BindingContext";
import {
    IPrCsszOzuspojSubmissionEntity,
    PrCsszOzuspojSubmissionEmployeeEntity,
    PrCsszOzuspojSubmissionEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { setCompanyRelation } from "@pages/payroll/submission/Submission.utils";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";
import { isObjectEmpty } from "@utils/general";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { FormStorage } from "../../../../views/formView/FormStorage";

export const HasDateEndLocalPath = BindingContext.localContext("hasDateEnd");
export const HasContactWorkerLocalPath = BindingContext.localContext("hasContactPerson");

class PrCSSZSubmissionOZUSPOJFormView extends SubmissionsFormViewForExtend<IPrCsszOzuspojSubmissionEntity> {
    typeCode = PrSubmissionTypeCode.EmployerDiscountOnSocialInsurance;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee = createPath(PrCsszOzuspojSubmissionEntity.Employee, PrCsszOzuspojSubmissionEmployeeEntity.Employee);

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;
        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            promises.push(setCompanyRelation(storage as unknown as FormStorage, { socialFields: true }));
        } else {
            // set local context for showing/hiding fields
            const hasDateEnd = !!entity.Detail?.DateEnd;
            storage.setValueByPath(HasDateEndLocalPath, hasDateEnd);

            const hasContactWorker = !isObjectEmpty(entity.Detail?.ContactWorker);
            storage.setValueByPath(HasContactWorkerLocalPath, hasContactWorker);
        }

        return Promise.all([...promises, super.typeSpecificOnAfterLoad(isNew)]).then();
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    onBeforeSave(data?: IPrCsszOzuspojSubmissionEntity): IPrCsszOzuspojSubmissionEntity {
        data = super.onBeforeSave(data);
        const { storage } = this.props;

        if (!data.Detail) {
            data.Detail = {};
        }

        // for termination the switch is hidden and stays false, but DateEnd is shown and required
        const isTermination = storage.getEntity().SubmissionSubtypeCode === PrSubmissionSubtypeCode.OzuspojTermination;

        if (!isTermination && !storage.getValueByPath(HasDateEndLocalPath)) {
            data.Detail.DateEnd = null;
        }

        if (!storage.getValueByPath(HasContactWorkerLocalPath)) {
            data.Detail.ContactWorker = null;
        }

        return data;
    }
}

export default withPermissionContext(PrCSSZSubmissionOZUSPOJFormView);